import { normalizeKey } from '../../shared/verteoffice'
import { generalToObjectiveType, objectiveToSpecificType } from './activityTypeMapping'
import { DOMAIN_CONFIG } from './domainConfig'

export interface ObjectiveOption {
  value: string
  label: string
  specificActivity: string
  generalActivity: string
}

export function buildAllObjectivesOptions(
  domainDataList: Record<string, string[]>
): ObjectiveOption[] {
  // Build specificActivity → generalActivity map at runtime from loaded domain data
  const specificToGeneral: Record<string, string> = {}
  for (const [generalName, objectiveDomainType] of Object.entries(generalToObjectiveType)) {
    const configItem = DOMAIN_CONFIG.find(c => normalizeKey(c.type) === normalizeKey(objectiveDomainType))
    if (!configItem) continue
    const specificActivityNames = domainDataList[configItem.listKey] ?? []
    for (const specificActivityName of specificActivityNames) {
      specificToGeneral[normalizeKey(specificActivityName)] = generalName
    }
  }

  // Build flat list of all objectives grouped by specific_activity
  const raw: ObjectiveOption[] = []
  for (const [specificActivityName, specificType] of Object.entries(objectiveToSpecificType)) {
    const configItem = DOMAIN_CONFIG.find(c => normalizeKey(c.type) === normalizeKey(specificType))
    if (!configItem) continue
    const objectives = domainDataList[configItem.listKey] ?? []
    const generalActivity = specificToGeneral[normalizeKey(specificActivityName)] ?? ''
    for (const objectiveName of objectives) {
      raw.push({
        value: objectiveName,
        label: objectiveName,
        specificActivity: specificActivityName,
        generalActivity
      })
    }
  }

  // Detect duplicate values and append parent context to label
  const counts: Record<string, number> = {}
  for (const opt of raw) {
    counts[opt.value] = (counts[opt.value] ?? 0) + 1
  }

  return raw.map(opt =>
    counts[opt.value] > 1
      ? { ...opt, label: `${opt.value} (${opt.specificActivity})` }
      : opt
  )
}
